<template>
	<svg :width="width" :height="height" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M7.64 39.5C5.62 37.84 4.5 35.18 4.5 32V16C4.5 9.16 7.16 6.5 14 6.5H26C30.08 6.5 34.36 7.26 35.28 12.96C35.42 13.78 34.86 14.54 34.04 14.68C33.22 14.82 32.46 14.26 32.32 13.44C31.9 10.84 30.8 9.5 26 9.5H14C8.84 9.5 7.5 10.84 7.5 16V32C7.5 33.3 7.76 35.72 9.54 37.18C10.18 37.7 10.28 38.66 9.74 39.3C9.46 39.66 9.02 39.84 8.6 39.84C8.26 39.84 7.92 39.72 7.64 39.5Z"
			:fill="color_prop" />
		<path
			d="M16 41.5C15.18 41.5 14.5 40.82 14.5 40C14.5 39.18 15.18 38.5 16 38.5H26C31.16 38.5 32.5 37.16 32.5 32V22C32.5 21.18 33.18 20.5 34 20.5C34.82 20.5 35.5 21.18 35.5 22V32C35.5 38.84 32.84 41.5 26 41.5H16Z"
			:fill="color_prop" />
		<path
			d="M38.4206 34.92L33.1406 31.22C32.4606 30.74 32.3006 29.8 32.7806 29.14C33.2606 28.46 34.1806 28.3 34.8606 28.78L40.1406 32.48C41.0206 33.1 41.6606 33.16 41.9206 33.02C42.1806 32.88 42.5006 32.34 42.5006 31.26V14C42.5006 13.18 43.1806 12.5 44.0006 12.5C44.8206 12.5 45.5006 13.18 45.5006 14V31.24C45.5006 34.1 44.1206 35.24 43.3006 35.66C42.9206 35.86 42.3406 36.08 41.6006 36.08C40.7406 36.08 39.6806 35.8 38.4206 34.92Z"
			:fill="color_prop" />
		<path
			d="M2.98188 45.4398C2.40188 44.8598 2.40188 43.8998 2.98188 43.3198L42.9819 3.31977C43.5619 2.73977 44.5219 2.73977 45.1019 3.31977C45.6819 3.89977 45.6819 4.85977 45.1019 5.43977L5.10187 45.4398C4.82187 45.7398 4.42187 45.8798 4.04187 45.8798C3.66187 45.8798 3.28188 45.7398 2.98188 45.4398Z"
			:fill="color_prop" />
	</svg>


</template>

<script>
export default {

	name: 'IconVideoSlash',

	props: {
		sizeMultiplier_prop: {
			type: Number,
			default: 1,
		},

		width_prop: {
			type: String,
			default: '3rem', // "px" or "em" only
		},

		height_prop: {
			type: String,
			default: '3rem', // "px" or "em" only
		},

		color_prop: {
			type: String,
			default: '#FFFFFF',
		}
	},

	data() {
		return {
		}
	},

	computed: {
		width() {
			// return Number(this.width_prop.substr(0, this.width_prop.length - 2)) * this.sizeMultiplier_prop + this.width_prop.substr(-2)
			const extracted = this.extractValueAndUnit(this.width_prop)
			return extracted.value * this.sizeMultiplier_prop + extracted.unit
		},

		height() {
			// return Number(this.height_prop.substr(0, this.height_prop.length - 2)) * this.sizeMultiplier_prop + this.height_prop.substr(-2)
			const extracted = this.extractValueAndUnit(this.height_prop)
			return extracted.value * this.sizeMultiplier_prop + extracted.unit
		},
	},

	methods: {
		// extract value and unit from a string. px, em, rem, %
		extractValueAndUnit(input) {
			const regex = /^([\d.]+)(px|em|rem|%)$/ // Matches numeric values with units
			const match = input.match(regex)

			if (match) {
				const value = parseFloat(match[1]) // Convert numeric part to a number
				const unit = match[2] // Extract unit part
				return { value, unit }
			}

			return { value: 0, unit: 'px' } // Default value
		}
	}
}
</script>

<style lang="css" scoped></style>